<template>
  <el-dialog
    append-to-body
    width="600px"
    title="提交OA流程"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      element-loading-text="加载中…"
      ref="elFormDom"
      :model="form"
      :rules="rules"
      label-width="130px"
      label-position="right"
      :size="subUnitSize"
    >
      <el-form-item prop="oa_phone" label="OA账号：">
        <el-input
          v-model="form.oa_phone"
          placeholder="请输入"
          clearable
        ></el-input>
        <div class="el-form-item-msg">提交OA流程后,请登录OA系统审批确认</div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="confirm"
          >确定</el-button
        >
        <el-button @click="toggle(false)">取消</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      form: {
        oa_phone: "",
      },
      info: {},
      list: [],
      rules: {
        oa_phone: [{ required: true, message: "必填", trigger: "change" }],
      },
    };
  },
  methods: {
    // 获取组织详情
    getDetail(list, info) {
      this.list = list;
      this.form.oa_phone = info.oa_phone;
      this.info = info;
    },
    reset(done) {
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    async confirm() {
      const isValid = await this.$refs.elFormDom.validate().catch(() => false);
      if (!isValid) return;
      this.loading = true;
      try {
        // 1. 查询接口
        const res1 = await this.$http.post("/admin/finance/search", {
          phone:this.form.oa_phone,
        });
        if (res1.code !== 1) {
          this.$message.warning(res1.msg);
          return;
        }
        // 2. 提交付款申请
        const params2 = {
          ids: this.list?.map((item) => item.id).join(",") || "",
          oa_phone: this.form.oa_phone,
          issued_day: this.info.issued_day,
          fees:this.info.fees,
          files:this.info.files,
        };
        const res2 = await this.$http.post(
          "/admin/finance/applyPayment",
          params2
        );
        if (res2.code === 1) {
          this.$message.success("提交成功");
          this.$emit("success");
          this.toggle(false);
        } else {
          this.$message.error(res2.msg || "提交失败");
        }
      } catch (err) {
        console.error("操作异常：", err);
        this.$message.error("网络异常或请求失败，请重试");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
